import { gasDeviceCustomFields, waterDeviceCustomFields } from 'src/app/+shared/custom-fields/common-custom-fields';
import { CustomField } from 'src/app/+shared/custom-fields/models';
import { CustomFieldConfig } from 'src/app/+shared/custom-fields/models/customFieldConfig';
import { InstallationFlowType } from 'src/app/constants/app.constants';

const gasDeviceFields: CustomField[] = [
  { ...gasDeviceCustomFields.ceNumber, row: 1 },
  { ...gasDeviceCustomFields.deviceRemovedCheckbox, row: 1, displayFunction: (_, isReadonly: boolean) => !isReadonly },
  { ...gasDeviceCustomFields.deviceName, row: 2 },
  { ...gasDeviceCustomFields.power, row: 2 },
  { ...gasDeviceCustomFields.selectedGasCategory, row: 10, label: 'facilities-data.form-fields.selected-gas-category' },
];

const waterDeviceFields: CustomField[] = [
  { ...waterDeviceCustomFields.specialApplianceDropDown, row: 1, required: true },
  { ...waterDeviceCustomFields.amount, row: 1, required: true },
  { ...waterDeviceCustomFields.vrCold, row: 2 },
  { ...waterDeviceCustomFields.vrHot, row: 2 },
];

export const configs: CustomFieldConfig[] = Object.values(InstallationFlowType).map(applicationType => ({
  applicationType,
  fields: [...gasDeviceFields, ...waterDeviceFields],
}));
